import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { MatSelect } from '@angular/material/select';
import { LocationModel } from '../../locations/location.model';
import { LocationSelectors } from '@states/location/location.selector-types';
import { routerSegments } from '@consts/routes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PermissionModel } from '@models/permission.model';
import { RbacPermissionService } from '../../authorization/rbac-permission.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  standalone: false,
})
export class LocationComponent implements OnInit {

  public ViewType = LocationModel.ViewType;
  private readonly canReadBuildings: () => boolean = inject(RbacPermissionService).createChecker([
    PermissionModel.Permissions.BuildingRead,
  ]);

  public viewType$: Observable<LocationModel.ViewType> = this.store$.pipe(select(LocationSelectors.selectViewType));

  @ViewChild('viewSelector') viewSelector: MatSelect;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store$: Store,
    private destroyRef: DestroyRef,
  ) {
  }

  ngOnInit(): void {
    this.viewType$.pipe(filter(viewType => !!viewType || viewType === LocationModel.ViewType.Home), takeUntilDestroyed(this.destroyRef))
      .subscribe((viewType) => {
        switch (viewType) {
          case LocationModel.ViewType.Home:

            // this.router.navigate([routerSegments.home], { relativeTo: this.route });
            break;
          case LocationModel.ViewType.Floors:
            // A view type saved in local storage may outlive the user's BuildingRead — stay on the
            // default view instead of bouncing off the floors route guard.
            if (!this.canReadBuildings()) {
              break;
            }
            this.router.navigate([routerSegments.floors], { relativeTo: this.route, queryParamsHandling: 'preserve' });

            break;
          case LocationModel.ViewType.Devices:
            // The devices view lives outside this shell, under `location/devices` - an absolute
            // navigation, not a child of `/location`.
            this.router.navigate([routerSegments.location, routerSegments.devices]);
            break;
          case LocationModel.ViewType.Map:
            this.router.navigate([routerSegments.map], { relativeTo: this.route });
            break;
        }
      });
  }
}
